import { useMemo } from 'react';

import { getUserLanguage } from '../../helpers';
import { ravenCaptureException } from '../../helpers/raven';

// navigator.language / navigator.languages may return tags with ;q=0.9 (similar to the Accept-Language header)
// Intl requires a clean BCP 47 tag (e.g., de), so de;q=0.9 is invalid.
const getCleanLanguageTag = (lang: string): string => lang.split(';')[0].trim();

const usePriceFormatter = (currency: string): Intl.NumberFormat | undefined => {
    const formatter = useMemo<Intl.NumberFormat | undefined>(() => {
        let currencyFormatter: Intl.NumberFormat | undefined;

        const lang = getUserLanguage();
        const language = getCleanLanguageTag(lang);

        try {
            currencyFormatter = new Intl.NumberFormat(language || 'en-US', {
                style: 'currency',
                currency,
                currencyDisplay: 'narrowSymbol',
            });
        } catch (e) {
            if (e instanceof Error) {
                ravenCaptureException('Wrong currency provided to recommended product', {
                    message: e.message,
                });
            }
        }
        return currencyFormatter;
    }, [currency]);

    return formatter;
};

export default usePriceFormatter;
